import { create } from "zustand";
import { getPlatformEnvironment, type PlatformEnvironment } from "../platform/platform-env";

type AuthStatus = "checking" | "signed-out" | "signed-in";
type LoginStatus = "idle" | "busy";
export type AppTab = "home" | "library" | "create" | "account";

type AppState = {
  authStatus: AuthStatus;
  loginStatus: LoginStatus;
  authError?: string;
  shellError?: string;
  member: unknown;
  selectedTab: AppTab;
  platform: PlatformEnvironment;
  beginAuthCheck: () => void;
  setLoginBusy: (busy: boolean) => void;
  setSignedOut: (error?: string) => void;
  setSignedIn: (member: unknown) => void;
  setSelectedTab: (tab: AppTab) => void;
  setShellError: (message?: string) => void;
  syncPlatform: () => void;
};

export const useAppStore = create<AppState>()((set) => ({
  authStatus: "checking",
  loginStatus: "idle",
  authError: undefined,
  shellError: undefined,
  member: null,
  selectedTab: "home",
  platform: getPlatformEnvironment(),
  beginAuthCheck: () => set({ authStatus: "checking", authError: undefined }),
  setLoginBusy: (busy) => set({ loginStatus: busy ? "busy" : "idle" }),
  setSignedOut: (error) => set({
    authStatus: "signed-out",
    loginStatus: "idle",
    authError: error,
    shellError: undefined,
    member: null,
  }),
  setSignedIn: (member) => set({
    authStatus: "signed-in",
    loginStatus: "idle",
    authError: undefined,
    shellError: undefined,
    member,
  }),
  setSelectedTab: (tab) => set({ selectedTab: tab }),
  setShellError: (message) => set({ shellError: message }),
  syncPlatform: () => set({ platform: getPlatformEnvironment() }),
}));
